export const normalizePrice = (mintPrice: string, selectedOption: number): string => {
    const result = Number(mintPrice) * selectedOption
    return result.toFixed(countDecimals(Number(mintPrice)))
}

export const normalizeEstimatedCost = (mintPrice: string, cost: string) => {
    const minimumDecimalPlaces = 4
    const mintPriceAsNumber = Number(mintPrice)
    const mintPriceDecimalPlaces = countDecimals(mintPriceAsNumber)

    const result = Number.parseFloat(cost)

    if (mintPriceDecimalPlaces < minimumDecimalPlaces) return result.toFixed(minimumDecimalPlaces)

    return result.toFixed(countDecimals(mintPriceAsNumber))
}

const countDecimals = function (value: number) {
    if (value % 1 != 0) return value.toString().split('.')[1].length
    return 0
}
